import { useState } from 'react';
import { api_with_method } from '../../../../../redux/api_funcs';
import { get_api_url } from '../../../../../utils/urls';

export interface PlanItem {
  session_per_week: number | null;
  months: number | null;
  is_best_value: boolean;
  type: string; // '1on1' | 'group'
}

export interface GroupClassItem {
  uuid: string;
  name: string;
}

export interface Notes {
  coach: string;
  ai: string;
  selected: 'teacher' | 'ai';
}

export interface Lifestyle {
  current: string[];
  goals: string[];
}

export interface PersonalisedPlanPayload {
  plans: PlanItem[];
  recommended_group_classes: GroupClassItem[];
  notes: Notes;
  lifestyle: Lifestyle;
  session_uuid?: string;
  teacher_uuid?: string;
}

export function useSavePersonalisedPlan(studentUuid: string) {
  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState<string | null>(null);
  const [shortUrl, setShortUrl] = useState<string | null>(null);

  const savePersonalisedPlan = async (payload: PersonalisedPlanPayload) => {
    const url = get_api_url(`/v2/cms_user/students/${studentUuid}/personalised_plans`, null, true);
    setIsSaving(true);
    setSaveError(null);
    setShortUrl(null);

    try {
      const res = await api_with_method('post', url, payload, true);

      setShortUrl(res?.data?.data?.short_url ?? null);
    } catch (err) {
      console.error('Error saving personalised plan', err);
      setSaveError('Failed to save personalised plan');
      throw err;
    } finally {
      setIsSaving(false);
    }
  };

  return { savePersonalisedPlan, shortUrl, isSaving, saveError };
}
